package twist.mena.sports.shared.dto.admin

import kotlinx.serialization.Serializable

@Serializable
data class TriggerTestRunRequest(
    val environment: String,
    val suites: List<String>
)
